import Swiper, {Autoplay} from 'swiper';

export default class LogoSliderHandler {

    constructor(el) {
        this.el = el;

        const swiper = new Swiper(el.querySelector('.js-logo-swiper-frame'), {
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            slidesPerView: "auto",
            spaceBetween: 16,
            modules: [Autoplay],
            breakpoints: {
                640: {spaceBetween: 32},
            }
        });
    }
}
